import useController from '@common/hooks/useController'

// Native shim — match web context shape { state, reverseLookup, resolveDomain }.
// Methods are no-op on RN; reverse-lookups happen inside WebViewWorker bundle.
export default function useDomainsController(): any {
  const { state } = useController('DomainsController' as any)
  return {
    state: state || {},
    reverseLookup: () => {},
    resolveDomain: () => {}
  }
}
